export default __webpack_public_path__ + "static/media/PassiveIncome.ccefc094.svg";